// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "@tailwind base;\n@tailwind components;\n@tailwind utilities;", "",{"version":3,"sources":["../node_modules/tailwindcss/base.css","../node_modules/tailwindcss/components.css","../node_modules/tailwindcss/utilities.css"],"names":[],"mappings":"AAAA,cAAA;ACAA,oBAAA;ACAA,mBAAA","file":"tailwind.scss","sourcesContent":["@tailwind base;\n","@tailwind components;\n","@tailwind utilities;\n"]}]);
// Exports
module.exports = exports;
